import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

type DisconnectChannelDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body: string;
  confirmLabel: string;
  isLoading?: boolean;
};

export default function DisconnectChannelDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel,
  isLoading = false,
}: DisconnectChannelDialogProps) {
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay bg="blackAlpha.500" backdropFilter="blur(6px)">
        <AlertDialogContent borderRadius="24px" mx={4}>
          <AlertDialogHeader fontSize="lg" fontWeight="800" color="gray.900">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text color="gray.600" lineHeight="1.8">
              {body}
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} onClick={onClose} borderRadius="full" variant="ghost">
              Cancel
            </Button>
            <Button
              colorScheme="red"
              borderRadius="full"
              onClick={onConfirm}
              isLoading={isLoading}
            >
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
